import React from 'react';
import {Link} from "react-router-dom";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import authService from "../services/auth/Service"

export default function Login() {

  const handleClose = () => {
    authService.login('any', 'any')
  };

  return (
    <div>
      <Dialog open={true}  aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">登陆</DialogTitle>
        <DialogContent>
          <DialogContentText>
            请使用您的邮箱与密码登陆
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="email"
            label="Email Address"
            type="email"
            fullWidth
          />
          <TextField
            autoFocus
            margin="dense"
            id="password"
            label="密码"
            type="password"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            取消
          </Button>
          <Button onClick={handleClose} color="primary" component={Link} to="/">
            登陆
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}